import React from 'react';
import ReactDOM from 'react-dom';
import {LocalizeProvider} from "react-localize-redux";
import queryString from "query-string";

import App from './components/App';
import Provider from "react-redux/es/components/Provider";
import createStore from "./store/store";

const initialValues = queryString.parse(window.location.search);

if (window.location.hostname !== 'localhost') {
	initialValues.apiOrigin = window.location.origin;
}

const store = createStore(initialValues);

ReactDOM.render(
	<Provider store={store}>
		<LocalizeProvider>
			<App />
		</LocalizeProvider>
	</Provider>,
	document.getElementById('plazaro-booking-form')
);



// WEBPACK FOOTER //
// ./src/index.js